import React, { FC } from 'react';
import { IonPage, IonRouterOutlet, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { Route, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchOnBoarding } from '../../redux/onBoarding/thunk';
import { resetOnBoarding, setIsLoading, setOnBoardingId } from '../../redux/onBoarding/reducer';
import { PublicRoutes } from '../../routes/navigation';
import OnBoardingMain from './pages/OnBoardingMain';
import OnBoardingQuestion from './pages/OnBoardingQuestion';
import OnBoardingInfo from './pages/OnBoardingInfo';
import OnBoardingResultInfo from './pages/OnBoardingResultInfo';
import useLangs from '../../context/LangsContext';
import OnBoardingReviews from './pages/OnBoardingReviews';
import OnBoardingSpecialists from './pages/OnBoardingSpecialists';
import OnBoardingRedirect from './pages/OnBoardingRedirect';
import useToast from '../../context/ToastContext/ToastContext';
import { setSplashColor } from '../../shared/utils/splashColor';
import { setSupportButtonActive } from '../../redux/supportButton/reducer';

interface OnBoardingProps extends RouteComponentProps<{ boardId: string }> {}

const OnBoarding: FC<OnBoardingProps> = ({ match }) => {
  const { boardId } = match.params;

  const { showToast } = useToast();
  const dispatch = useDispatch();
  const { changeLocale } = useLangs();

  useIonViewDidEnter(async () => {
    setSplashColor('#fffffe');

    try {
      dispatch(resetOnBoarding());
      dispatch(setIsLoading(true));

      const dataBoard = await dispatch(fetchOnBoarding(boardId)).unwrap();
      changeLocale(dataBoard.lang);
      dispatch(setOnBoardingId(boardId));
    } catch (error: any) {
      showToast({ error });
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [boardId]);

  useIonViewWillEnter(() => {
    dispatch(setSupportButtonActive(false));
  });

  return (
    <IonPage>
      <IonRouterOutlet animated={false}>
        <Route exact path={PublicRoutes.ON_BOARDING} component={OnBoardingMain} />
        <Route exact path={PublicRoutes.ON_BOARDING_QUESTION} component={OnBoardingQuestion} />
        <Route exact path={PublicRoutes.ON_BOARDING_INFO} component={OnBoardingInfo} />
        <Route exact path={PublicRoutes.ON_BOARDING_REVIEWS} component={OnBoardingReviews} />
        <Route exact path={PublicRoutes.ON_BOARDING_RESULT_INFO} component={OnBoardingResultInfo} />
        <Route exact path={PublicRoutes.ON_BOARDING_SPECIALIST} component={OnBoardingSpecialists} />
        <Route exact path={PublicRoutes.ON_BOARDING_REDIRECT} component={OnBoardingRedirect} />
      </IonRouterOutlet>
    </IonPage>
  );
};

export default OnBoarding;
